import { Link } from '@tanstack/react-router'
import { SonCta } from '../components/cta'
import { Reveal, Stagger, StaggerItem } from '../components/hareket'
import { Mockup } from '../components/mockup'
import { ModulKarti } from '../components/modul-karti'
import { Baslik, ButonLink, DEMO_YOLU, Eyebrow, Kart, SayfaUstu, Section } from '../components/ui'
import { COZUMLER, COZUM_HARITASI } from '../icerik/cozumler'
import { modulBul } from '../icerik/moduller'
import { useHead } from '../lib/head'

export function Cozumler() {
  useHead(
    {
      title: 'Çözümler',
      description:
        'Meslek dernekleri, federasyonlar, eğitim dernekleri, hemşehri dernekleri, spor kulüpleri ve vakıflar için Akıllı Dernek.',
    },
    '/cozumler',
  )
  return (
    <>
      <SayfaUstu>
        <Section className="pt-0 sm:pt-0">
          <Reveal>
            <Baslik
              seviye="h1"
              eyebrow="Çözümler"
              baslik="Derneğinizin işine göre"
              metin="Aynı platform, farklı gün. Her dernek tipi için hangi modüllerin öne çıktığını ve bir günün nasıl geçtiğini anlattık."
            />
          </Reveal>
          <Stagger className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {COZUMLER.map((c) => (
              <StaggerItem key={c.slug} className="h-full">
                <Link
                  to={`/cozumler/${c.slug}`}
                  className="flex h-full flex-col rounded-[var(--radius-panel)] bg-surface p-5 ring-soft transition-transform duration-300 hover:-translate-y-0.5"
                >
                  <c.ikon className="size-5 text-brand" aria-hidden />
                  <p className="mt-4 font-semibold text-ink">{c.ad}</p>
                  <p className="mt-1.5 text-sm leading-relaxed text-ink-2">{c.kisa}</p>
                </Link>
              </StaggerItem>
            ))}
          </Stagger>
        </Section>
      </SayfaUstu>
      <SonCta />
    </>
  )
}

export function CozumSayfasi({ slug }: { slug: string }) {
  const c = COZUM_HARITASI.get(slug)
  if (!c) throw new Error(`Çözüm yok: ${slug}`)
  useHead({ title: c.ad, description: c.kisa }, `/cozumler/${slug}`)
  const ilkModul = modulBul(c.moduller[0])
  return (
    <>
      <SayfaUstu>
        <Section className="pt-0 sm:pt-0">
          <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
            <Reveal>
              <Eyebrow>Kimler için</Eyebrow>
              <h1 className="display mt-4 text-balance text-4xl text-ink sm:text-5xl">{c.ad}</h1>
              <p className="mt-5 text-pretty text-lg leading-relaxed text-ink-2">{c.aciklama}</p>
              <div className="mt-7">
                <ButonLink to={DEMO_YOLU} ok>
                  Demo isteyin
                </ButonLink>
              </div>
            </Reveal>
            <Reveal delay={0.1} y={24}>
              <Mockup anahtar={ilkModul.mockup} />
            </Reveal>
          </div>
        </Section>
      </SayfaUstu>

      <Section className="bg-surface/60">
        <Reveal>
          <Baslik eyebrow="İhtiyaçlar" baslik="Bu derneklerde ne öne çıkar" />
        </Reveal>
        <Stagger className="mt-10 grid gap-4 sm:grid-cols-2">
          {c.ihtiyaclar.map((i) => (
            <StaggerItem key={i.baslik}>
              <Kart className="h-full p-5">
                <p className="font-semibold text-ink">{i.baslik}</p>
                <p className="mt-1.5 text-sm leading-relaxed text-ink-2">{i.aciklama}</p>
              </Kart>
            </StaggerItem>
          ))}
        </Stagger>
      </Section>

      <Section>
        <div className="grid gap-10 lg:grid-cols-[1fr_1.4fr] lg:gap-16">
          <Reveal>
            <Baslik
              eyebrow="Bir gün"
              baslik="Panelde bir gün nasıl geçer"
              metin="Kurgu; ama her adımı bugünkü ya da yol haritasındaki bir özelliğe dayanır."
            />
          </Reveal>
          <Reveal delay={0.1}>
            <ol className="space-y-5">
              {c.gun.map((g) => (
                <li key={g.saat} className="grid grid-cols-[56px_1fr] gap-4">
                  <span className="data pt-0.5 text-sm font-semibold text-brand">{g.saat}</span>
                  <p className="text-[15px] leading-relaxed text-ink-2">{g.olay}</p>
                </li>
              ))}
            </ol>
          </Reveal>
        </div>
      </Section>

      <Section className="bg-surface/60">
        <Reveal>
          <Baslik eyebrow="Modüller" baslik="Bu dernekler için öne çıkan modüller" />
        </Reveal>
        <Stagger className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {c.moduller.map((s) => (
            <StaggerItem key={s} className="h-full">
              <ModulKarti modul={modulBul(s)} />
            </StaggerItem>
          ))}
        </Stagger>
      </Section>
      <SonCta />
    </>
  )
}
